import mavonEditor from "./mavonEditor.vue";
export default mavonEditor;
